export const tokens = {
    radius: {
        sm: 8,
        md: 12,
        lg: 16,
    },
    layout: {
        maxWidth: 1200,
        headerHeight: 64,
    },
    typography: {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontFamilyMonospace: 'Monaco, Courier, monospace',
    },
};
